
import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomeView from './views/HomeView';
import PrinterOwnerView from './views/PrinterOwnerView';
import AboutView from './views/AboutView';
import ForMakersView from './views/ForMakersView';
import { AppRoute } from './types';

const App: React.FC = () => {
  const [currentRoute, setCurrentRoute] = useState<AppRoute>(AppRoute.HOME);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentRoute]);

  const renderContent = () => {
    switch (currentRoute) {
      case AppRoute.HOME:
        return <HomeView onNavigate={setCurrentRoute} />;
      case AppRoute.PRINTER_OWNER:
        return <PrinterOwnerView />;
      case AppRoute.ABOUT:
        return <AboutView />;
      case AppRoute.FOR_MAKERS:
        return <ForMakersView />;
      default:
        return <HomeView onNavigate={setCurrentRoute} />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar onNavigate={setCurrentRoute} activeRoute={currentRoute} />
      <main className="flex-grow pt-16">
        {renderContent()}
      </main>
      <Footer onNavigate={setCurrentRoute} />
    </div>
  );
};

export default App;
